import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin: auto;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #d9368b;
  width: 50px;
  height: 50px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 1s linear infinite;

  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export function PleaseWaitMessage({ entities }) {
  return <>{entities === null && <Wrapper />}</>;
}

export function NoRecordsFoundMessage({ entities }) {
  const customersList = entities === null ? [] : entities;
  return (
    <>
      {customersList.length === 0 && entities !== null && (
        <div style={{ margin: "auto" }}><img src="/assets/images/no_records.jpg" alt="No records" ></img><h4 style={{textAlign: "center"}}>No Records Found</h4></div>
      )}
    </>
  );
}
